module.exports = __webpack_public_path__ + "static/media/Northville-Commons-By-Laws.a7432721.pdf";